// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Css_Js_Core = require("bs-css/src/Css_Js_Core.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var PlaybackTrigger$SmartcutsMacros = require("./PlaybackTrigger.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("./DOM__HtmlElement.bs.js");
var SharedModalTypes$SmartcutsMacros = require("./SharedModalTypes.bs.js");
var SmartcutExecution$SmartcutsMacros = require("./SmartcutExecution.bs.js");
var PermissionAndOrigin$SmartcutsMacros = require("./PermissionAndOrigin.bs.js");
var RenderOnHost__Geometry$SmartcutsMacros = require("./RenderOnHost__Geometry.bs.js");
var MultiUrlTriggering__Shared$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__Shared.bs.js");

function t_encode(v) {
  if (typeof v === "number") {
    if (v === /* ExplainHighlightElement */0) {
      return ["ExplainHighlightElement"];
    } else {
      return ["MasterSecretPrompt"];
    }
  }
  switch (v.TAG | 0) {
    case /* SmartcutPlaybackForm */0 :
        return [
                "SmartcutPlaybackForm",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
              ];
    case /* UrlHighlightModal */1 :
        return [
                "UrlHighlightModal",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0),
                SmartcutExecution$SmartcutsMacros.ExecutionSet.multiUrlTriggeringTrigger_encode(v._1),
                Decco.optionToJson((function (param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.initState_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
                      }), v._2)
              ];
    case /* ExplainExtensionPermissions */2 :
        return [
                "ExplainExtensionPermissions",
                Decco.arrayToJson(PermissionAndOrigin$SmartcutsMacros.t_encode, v._0),
                PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_encode(v._1)
              ];
    case /* ConfirmExecutionQuotaModal */3 :
        return [
                "ConfirmExecutionQuotaModal",
                Decco.intToJson(v._0),
                PlaybackTrigger$SmartcutsMacros.t_encode(v._1)
              ];
    case /* LogInToWebsiteToContinuePlayback */4 :
        return [
                "LogInToWebsiteToContinuePlayback",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1),
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._2)
              ];
    case /* SaveSmartcutProgressModal */5 :
        return [
                "SaveSmartcutProgressModal",
                Decco.stringToJson(v._0),
                SharedModalTypes$SmartcutsMacros.SavingSmartcutProgress.t_encode(v._1)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ConfirmExecutionQuotaModal" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ConfirmExecutionQuotaModal */3,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ExplainExtensionPermissions" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.arrayFromJson(PermissionAndOrigin$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ExplainExtensionPermissions */2,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "ExplainHighlightElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExplainHighlightElement */0
                  };
          }
      case "LogInToWebsiteToContinuePlayback" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$7 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              if (match$7.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* LogInToWebsiteToContinuePlayback */4,
                          _0: match$5._0,
                          _1: match$6._0,
                          _2: match$7._0
                        }
                      };
              }
              var e$4 = match$7._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "MasterSecretPrompt" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MasterSecretPrompt */1
                  };
          }
      case "SaveSmartcutProgressModal" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$9 = SharedModalTypes$SmartcutsMacros.SavingSmartcutProgress.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$8.TAG === /* Ok */0) {
            if (match$9.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SaveSmartcutProgressModal */5,
                        _0: match$8._0,
                        _1: match$9._0
                      }
                    };
            }
            var e$7 = match$9._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "SmartcutPlaybackForm" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SmartcutPlaybackForm */0,
                      _0: v0._0
                    }
                  };
          }
          var e$9 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "UrlHighlightModal" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$10 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$11 = SmartcutExecution$SmartcutsMacros.ExecutionSet.multiUrlTriggeringTrigger_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$12 = Decco.optionFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.initState_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
                }), Belt_Array.getExn(jsonArr$1, 3));
          if (match$10.TAG === /* Ok */0) {
            if (match$11.TAG === /* Ok */0) {
              if (match$12.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* UrlHighlightModal */1,
                          _0: match$10._0,
                          _1: match$11._0,
                          _2: match$12._0
                        }
                      };
              }
              var e$10 = match$12._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                      }
                    };
            }
            var e$11 = match$11._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$11.path,
                      message: e$11.message,
                      value: e$11.value
                    }
                  };
          }
          var e$12 = match$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(v) {
  if (typeof v === "number") {
    if (v === /* ExplainHighlightElement */0) {
      return "ExplainHighlightElement";
    } else {
      return "MasterSecretPrompt";
    }
  }
  switch (v.TAG | 0) {
    case /* SmartcutPlaybackForm */0 :
        return "SmartcutPlaybackForm(" + (v._0 + ")");
    case /* UrlHighlightModal */1 :
        return "UrlHighlightModal(" + (v._0 + (", " + (SmartcutExecution$SmartcutsMacros.ExecutionSet.stringifyMultiUrlTriggeringTrigger(v._1) + (", " + ((
                          v._2 !== undefined ? "Some(initState)" : "None"
                        ) + ")")))));
    case /* ExplainExtensionPermissions */2 :
        return "ExplainExtensionPermissions(permissions, permissionTrigger)";
    case /* ConfirmExecutionQuotaModal */3 :
        return "ConfirmExecutionQuotaModal(" + (String(v._0) + (", " + (PlaybackTrigger$SmartcutsMacros.stringify(v._1) + ")")));
    case /* LogInToWebsiteToContinuePlayback */4 :
        return "LogInToWebsiteToContinuePlayback(" + (v._0 + (", " + (StringUtils$SmartcutsMacros.quote(v._1) + (", " + (v._2 + ")")))));
    case /* SaveSmartcutProgressModal */5 :
        return "SaveSmartcutProgressModal(smartcutName=" + (v._0 + (", progress=" + (SharedModalTypes$SmartcutsMacros.SavingSmartcutProgress.stringify(v._1) + ")")));
    
  }
}

var containerId = "smartcuts-iframe";

var container = CssJs.style([
      CssJs.position("fixed"),
      CssJs.zIndex(20000)
    ]);

var iframe = CssJs.style([
      CssJs.position("fixed"),
      CssJs.width({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.height({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.maxHeight({
            NAME: "calc",
            VAL: [
              "sub",
              {
                NAME: "vh",
                VAL: 100.0
              },
              {
                NAME: "px",
                VAL: 100
              }
            ]
          })
    ]);

var fullHeight = CssJs.style([CssJs.maxHeight({
            NAME: "vh",
            VAL: 100.0
          })]);

var smartcutPlaybackForm = CssJs.style([CssJs.selector("iframe", [
            CssJs.marginTop({
                  NAME: "px",
                  VAL: 20
                }),
            CssJs.marginLeft({
                  NAME: "percent",
                  VAL: 50.0
                }),
            CssJs.transform({
                  NAME: "translateX",
                  VAL: {
                    NAME: "percent",
                    VAL: -50.0
                  }
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
                      NAME: "px",
                      VAL: 3
                    }, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    })),
            CssJs.borderRadius({
                  NAME: "px",
                  VAL: 5
                })
          ])]);

var urlHighlightModal = CssJs.style([CssJs.selector("iframe", [
            CssJs.maxHeight({
                  NAME: "vh",
                  VAL: 100.0
                }),
            CssJs.maxWidth({
                  NAME: "px",
                  VAL: 500
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box({
                      NAME: "px",
                      VAL: 3
                    }, undefined, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    }))
          ])]);

var explainExtensionPermissions = CssJs.style([CssJs.selector("iframe", [
            CssJs.maxWidth({
                  NAME: "px",
                  VAL: 500
                }),
            CssJs.maxHeight({
                  NAME: "px",
                  VAL: 350
                }),
            CssJs.marginTop({
                  NAME: "px",
                  VAL: 20
                }),
            CssJs.marginLeft({
                  NAME: "percent",
                  VAL: 50.0
                }),
            CssJs.transform({
                  NAME: "translateX",
                  VAL: {
                    NAME: "percent",
                    VAL: -50.0
                  }
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
                      NAME: "px",
                      VAL: 3
                    }, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    })),
            CssJs.borderRadius({
                  NAME: "px",
                  VAL: 5
                })
          ])]);

var loginToWebsite = CssJs.style([CssJs.selector("iframe", [
            CssJs.maxWidth({
                  NAME: "px",
                  VAL: 500
                }),
            CssJs.maxHeight({
                  NAME: "px",
                  VAL: 330
                }),
            CssJs.marginTop({
                  NAME: "px",
                  VAL: 20
                }),
            CssJs.marginLeft({
                  NAME: "percent",
                  VAL: 50.0
                }),
            CssJs.transform({
                  NAME: "translateX",
                  VAL: {
                    NAME: "percent",
                    VAL: -50.0
                  }
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
                      NAME: "px",
                      VAL: 3
                    }, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    })),
            CssJs.borderRadius({
                  NAME: "px",
                  VAL: 5
                })
          ])]);

var saveSmartcutProgressModal = CssJs.style([CssJs.selector("iframe", [
            CssJs.maxWidth({
                  NAME: "px",
                  VAL: 500
                }),
            CssJs.maxHeight({
                  NAME: "px",
                  VAL: 330
                }),
            CssJs.marginTop({
                  NAME: "px",
                  VAL: 20
                }),
            CssJs.marginLeft({
                  NAME: "percent",
                  VAL: 50.0
                }),
            CssJs.transform({
                  NAME: "translateX",
                  VAL: {
                    NAME: "percent",
                    VAL: -50.0
                  }
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
                      NAME: "px",
                      VAL: 3
                    }, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    })),
            CssJs.borderRadius({
                  NAME: "px",
                  VAL: 5
                })
          ])]);

var confirmExecutionQuotaModal = CssJs.style([CssJs.selector("iframe", [
            CssJs.maxWidth({
                  NAME: "px",
                  VAL: 500
                }),
            CssJs.maxHeight({
                  NAME: "px",
                  VAL: 420
                }),
            CssJs.marginTop({
                  NAME: "px",
                  VAL: 20
                }),
            CssJs.marginLeft({
                  NAME: "percent",
                  VAL: 50.0
                }),
            CssJs.transform({
                  NAME: "translateX",
                  VAL: {
                    NAME: "percent",
                    VAL: -50.0
                  }
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
                      NAME: "px",
                      VAL: 3
                    }, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    })),
            CssJs.borderRadius({
                  NAME: "px",
                  VAL: 5
                })
          ])]);

var explainHighlightElement = CssJs.style([CssJs.selector("iframe", [
            CssJs.maxWidth({
                  NAME: "px",
                  VAL: 500
                }),
            CssJs.maxHeight({
                  NAME: "px",
                  VAL: 480
                }),
            CssJs.marginTop({
                  NAME: "px",
                  VAL: 20
                }),
            CssJs.marginLeft({
                  NAME: "percent",
                  VAL: 50.0
                }),
            CssJs.transform({
                  NAME: "translateX",
                  VAL: {
                    NAME: "percent",
                    VAL: -50.0
                  }
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
                      NAME: "px",
                      VAL: 3
                    }, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    })),
            CssJs.borderRadius({
                  NAME: "px",
                  VAL: 5
                })
          ])]);

var masterSecretPrompt = CssJs.style([CssJs.selector("iframe", [
            CssJs.maxWidth({
                  NAME: "px",
                  VAL: 500
                }),
            CssJs.maxHeight({
                  NAME: "px",
                  VAL: 200
                }),
            CssJs.marginTop({
                  NAME: "px",
                  VAL: 20
                }),
            CssJs.marginLeft({
                  NAME: "percent",
                  VAL: 50.0
                }),
            CssJs.transform({
                  NAME: "translateX",
                  VAL: {
                    NAME: "percent",
                    VAL: -50.0
                  }
                }),
            CssJs.boxShadow(Css_Js_Core.Shadow.box(undefined, {
                      NAME: "px",
                      VAL: 3
                    }, {
                      NAME: "px",
                      VAL: 10
                    }, undefined, undefined, {
                      NAME: "rgba",
                      VAL: [
                        0,
                        0,
                        0,
                        {
                          NAME: "num",
                          VAL: 0.15
                        }
                      ]
                    })),
            CssJs.borderRadius({
                  NAME: "px",
                  VAL: 5
                })
          ])]);

var withOverlay = CssJs.style([
      CssJs.top("zero"),
      CssJs.left("zero"),
      CssJs.width({
            NAME: "percent",
            VAL: 100.0
          }),
      CssJs.height({
            NAME: "percent",
            VAL: 100.0
          }),
      CssJs.background({
            NAME: "rgba",
            VAL: [
              0,
              0,
              0,
              {
                NAME: "num",
                VAL: 0.15
              }
            ]
          })
    ]);

var Style = {
  container: container,
  iframe: iframe,
  fullHeight: fullHeight,
  smartcutPlaybackForm: smartcutPlaybackForm,
  urlHighlightModal: urlHighlightModal,
  explainExtensionPermissions: explainExtensionPermissions,
  loginToWebsite: loginToWebsite,
  saveSmartcutProgressModal: saveSmartcutProgressModal,
  confirmExecutionQuotaModal: confirmExecutionQuotaModal,
  explainHighlightElement: explainHighlightElement,
  masterSecretPrompt: masterSecretPrompt,
  withOverlay: withOverlay
};

function createOrResetContainerAndIframe(param) {
  var htmlDocument = document;
  var createIframe = function (container) {
    var iframe$1 = htmlDocument.createElement("iframe");
    var classList = iframe$1.classList;
    classList.add(iframe);
    iframe$1.setAttribute("frameborder", "0");
    container.appendChild(iframe$1);
    return iframe$1;
  };
  var container$1 = document.getElementById(containerId);
  var match;
  if (container$1 == null) {
    var container$2 = htmlDocument.createElement("div");
    container$2.id = containerId;
    var arg = htmlDocument.body;
    var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
    var prim0 = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
        })("Expect to get body");
    prim0.appendChild(container$2);
    match = [
      container$2,
      createIframe(container$2)
    ];
  } else {
    var iframe$1 = container$1.querySelector("iframe");
    if (iframe$1 == null) {
      match = [
        container$1,
        createIframe(container$1)
      ];
    } else {
      container$1.removeChild(iframe$1);
      match = [
        container$1,
        createIframe(container$1)
      ];
    }
  }
  var container$3 = match[0];
  container$3.className = container;
  return [
          container$3,
          match[1]
        ];
}

function render(iframeContent) {
  var match = createOrResetContainerAndIframe(undefined);
  var iframe = match[1];
  var container = match[0];
  if (typeof iframeContent === "number") {
    if (iframeContent === /* ExplainHighlightElement */0) {
      container.classList.add(withOverlay, explainHighlightElement);
    } else {
      container.classList.add(withOverlay, masterSecretPrompt);
    }
  } else {
    switch (iframeContent.TAG | 0) {
      case /* SmartcutPlaybackForm */0 :
          container.classList.add(withOverlay, smartcutPlaybackForm);
          break;
      case /* UrlHighlightModal */1 :
          container.classList.add(urlHighlightModal);
          break;
      case /* ExplainExtensionPermissions */2 :
          container.classList.add(withOverlay, explainExtensionPermissions);
          break;
      case /* ConfirmExecutionQuotaModal */3 :
          container.classList.add(withOverlay, confirmExecutionQuotaModal);
          break;
      case /* LogInToWebsiteToContinuePlayback */4 :
          container.classList.add(withOverlay, loginToWebsite);
          break;
      case /* SaveSmartcutProgressModal */5 :
          container.classList.add(withOverlay, saveSmartcutProgressModal);
          break;
      
    }
  }
  iframe.setAttribute("style", "display: none");
  iframe.setAttribute("src", browser.runtime.getURL("html/iframe.html?content=" + encodeURIComponent(JSON.stringify(t_encode(iframeContent)))));
  iframe.onload = (function (param) {
      iframe.removeAttribute("style");
      
    });
  return Promise.resolve(iframe);
}

function resizeAndReposition(param) {
  var maybePosition = param.position;
  var maybeHeightUpdate = param.height;
  var maybeWidthUpdate = param.width;
  var container = document.querySelector("#" + containerId + " iframe");
  if (container == null) {
    return ;
  }
  if (maybeWidthUpdate !== undefined) {
    container.style.width = RenderOnHost__Geometry$SmartcutsMacros.Length.toCSSValue(maybeWidthUpdate);
  }
  if (maybeHeightUpdate !== undefined) {
    container.style.height = RenderOnHost__Geometry$SmartcutsMacros.Length.toCSSValue(maybeHeightUpdate);
  }
  if (maybePosition === undefined) {
    return ;
  }
  switch (maybePosition) {
    case /* Left */0 :
        container.style.top = "0";
        container.style.right = "";
        container.style.left = "0";
        return ;
    case /* Right */1 :
        container.style.top = "0";
        container.style.left = "";
        container.style.right = "0";
        return ;
    case /* Default */2 :
        container.style.left = "";
        container.style.right = "";
        return ;
    
  }
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.containerId = containerId;
exports.Style = Style;
exports.render = render;
exports.resizeAndReposition = resizeAndReposition;
/* container Not a pure module */
